import type { RouteRecordRaw } from "vue-router"
import { v4 as uuidv4 } from "uuid"

export const getDefaultRouteName = (route: RouteRecordRaw) => {
  return route.name || (route.path || route.redirect?.toString() || uuidv4()).replace(/\//g, "_")
}
